/**
 * AccountSecurity — top-level sub-page:
 * change password · logout · logout-all · (super_admin only) manage users.
 */
import { useState } from "react";
import { ArrowRight, KeyRound, LogOut, ShieldCheck, Users } from "lucide-react";
import UserManagement from "@/pages/admin/UserManagement";

export default function AccountSecurity({ onBack, me, onChangePw, onLogout, onLogoutAll }) {
  const [showUsers, setShowUsers] = useState(false);
  if (showUsers) return <UserManagement onBack={() => setShowUsers(false)} />;

  const cards = [
    { key: "change-pw", label: "تغيير كلمة المرور", desc: "تحديث كلمة مرورك مع تسجيل خروج فوري", Icon: KeyRound, tone: "bg-white border-slate-200 hover:border-slate-400", testid: "as-change-pw-btn", onClick: onChangePw },
    { key: "logout", label: "تسجيل الخروج", desc: "إنهاء الجلسة على هذا الجهاز فقط", Icon: LogOut, tone: "bg-white border-slate-200 hover:border-slate-400", testid: "admin-logout-btn", onClick: onLogout },
    { key: "logout-all", label: "الخروج من جميع الأجهزة", desc: "إبطال جميع الجلسات النشطة فوراً", Icon: LogOut, tone: "bg-red-50 border-red-200 hover:border-red-300 text-red-900", testid: "admin-logout-all-btn", onClick: onLogoutAll },
  ];
  if (me?.is_super_admin) {
    cards.push({ key: "users", label: "إدارة المستخدمين", desc: "إنشاء حسابات · تعديل الصلاحيات · إعادة تعيين كلمة المرور", Icon: Users, tone: "bg-slate-50 border-slate-200 hover:border-slate-400", testid: "as-manage-users-btn", onClick: () => setShowUsers(true) });
  }

  return (
    <div data-testid="account-security-panel" className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b-2 border-slate-900 pb-6">
        <div>
          <div className="text-sm font-bold text-slate-500 mb-2">دوائي / لوحة الإدارة</div>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-2">
            <ShieldCheck className="w-7 h-7" />الحساب والأمان
          </h1>
        </div>
        <button type="button" onClick={onBack} data-testid="as-back-btn"
          className="inline-flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-900 font-bold px-4 py-3 rounded-xl cursor-pointer">
          <ArrowRight className="w-4 h-4" /><span>العودة إلى لوحة الأدمن</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map(c => {
          const Icon = c.Icon;
          return (
            <button key={c.key} type="button" data-testid={c.testid} onClick={c.onClick}
              className={`text-right flex flex-col gap-2 border-2 rounded-2xl p-5 min-h-[110px] cursor-pointer ${c.tone}`}>
              <Icon className="w-6 h-6" />
              <span className="font-bold text-lg text-slate-900">{c.label}</span>
              <span className="text-xs text-slate-600">{c.desc}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
